(function () {
  'use strict';

  /* @ngdoc object
   * @name authentication.login
   * @description
   *
   */
  angular
  .module('neo.authentication.login', [
    'ui.router',
    'ngMaterial'
  ]);
}());
